import { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { APP_NAME, APP_SUB, LOGO_URL } from "@/components/common";
import { Printer, QrCode } from "lucide-react";

export function QrButtons({ santri, compact = false }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      {compact
        ? <Button variant="ghost" size="icon" className="h-7 w-7 shrink-0" data-testid={`qr-btn-${santri.no_induk_pondok}`} onClick={() => setOpen(true)}><QrCode className="h-4 w-4 text-emerald-600" /></Button>
        : <Button variant="outline" className="gap-2 rounded-xl bg-white/60 text-emerald-800 border-emerald-200 dark:bg-white/5 dark:text-emerald-300 dark:border-white/10" data-testid="lihat-qr-button" onClick={() => setOpen(true)}><QrCode className="h-4 w-4" /> Lihat / Cetak QR</Button>}
      <QrModal santri={open ? santri : null} onClose={() => setOpen(false)} />
    </>
  );
}

export function QrModal({ santri, onClose }) {
  if (!santri) return null;
  const val = String(santri.no_induk_pondok || "");
  return (
    <Dialog open={!!santri} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-sm" data-testid="qr-modal">
        <DialogHeader><DialogTitle className="truncate">QR Santri — {santri.nama}</DialogTitle></DialogHeader>
        <div className="flex flex-col items-center gap-3 py-1">
          <div className="bg-white p-3 rounded-xl border border-emerald-100"><QRCodeCanvas value={val} size={200} data-testid="qr-canvas" /></div>
          <div className="text-center">
            <p className="font-bold text-emerald-950">{santri.nama}</p>
            <p className="text-sm text-slate-500">No. Induk {val}{santri.nidi ? ` · NIDI ${santri.nidi}` : ""}</p>
            <p className="text-xs text-slate-400">{santri.departemen || "-"} · {santri.ribath || "-"}</p>
          </div>
          <Button className="gap-2 rounded-xl bg-emerald-700 hover:bg-emerald-800 w-full" data-testid="qr-print-button" onClick={() => window.print()}><Printer className="h-4 w-4" /> Cetak QR Sementara</Button>
          <p className="text-[11px] text-slate-400 text-center">Scan QR ini di menu Input Absensi (termasuk Ngaji Dhuha) — kehadiran tercatat otomatis. Isi QR = No. Induk, identik dengan E-KTS resmi.</p>
        </div>

        <div id="qr-print">
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh", padding: "10mm" }}>
            <div style={{ width: "92mm", border: "2px solid #0b5a41", borderRadius: 14, padding: "6mm", fontFamily: "sans-serif", color: "#111", boxSizing: "border-box" }}>
              {/* header */}
              <div style={{ display: "flex", alignItems: "center", gap: 8, borderBottom: "1px solid #cfe0d8", paddingBottom: "3mm", marginBottom: "3mm" }}>
                <img src={LOGO_URL} alt="logo" crossOrigin="anonymous" style={{ height: "12mm", width: "auto", display: "block" }} />
                <div>
                  <div style={{ fontWeight: 800, fontSize: 14, color: "#0b5a41", lineHeight: 1.1 }}>Pondok Pesantren Mamba'us Sholihin</div>
                  <div style={{ fontSize: 10, color: "#5a6b62" }}>Suci - Manyar - Gresik</div>
                </div>
              </div>
              {/* body: QR kiri + detail kanan */}
              <div style={{ display: "flex", alignItems: "center", gap: "5mm" }}>
                <div style={{ border: "1.5px solid #0b5a41", borderRadius: 8, padding: 6, flexShrink: 0 }}>
                  <QRCodeCanvas value={val} size={120} />
                </div>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontWeight: 800, fontSize: 16, color: "#1a2536", lineHeight: 1.15 }}>{santri.nama}</div>
                  <div style={{ fontSize: 12, marginTop: 4 }}>No. Induk: <b>{val}</b></div>
                  {santri.nidi ? <div style={{ fontSize: 12 }}>NIDI: {santri.nidi}</div> : null}
                  <div style={{ fontSize: 11, color: "#556", marginTop: 4 }}>{santri.departemen || "-"}</div>
                  <div style={{ fontSize: 11, color: "#556" }}>{santri.ribath || "-"}</div>
                </div>
              </div>
              <div style={{ fontSize: 9, color: "#99a", marginTop: "4mm", textAlign: "center" }}>Kartu QR Sementara untuk absensi · Kartu resmi (E-KTS) menyusul</div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
